'use strict'

const classes = ['vicecity',
 'mild',
 'dawn',
 'ibizasunset',
 'eightiespurple',
 'blackrosé',
 'bradybradyfunfun',
 'edssunsetgradient',
 'snapchat',
 'cosmicfusion',
 'nepal',
 'azurepop',
 'lovecouple',
 'disco',
 'limeade',
 'dania',
 'fiftyshadesofgrey',
 'dusk',
 'iiitdelhi',
 'sunonthehorizon',
 'bloodred',
 'sherbert',
 'firewatch',
 'lush',
 'frost',
 'mauve',
 'royal',
 'minimalred',
 'dusk',
 'deepseaspace',
 'grapefruitsunset',
 'sunset',
 'solidvault',
 'brightvault',
 'politics',
 'sweetmorning',
 'sylvia',
 'transfile',
 'tranquil',
 'redocean',
 'shahabi',
 'alihossein',
 'ali',
 'purplewhite',
 'colorsofsky',
 'decent',
 'deepspace',
 'darkskies',
 'suzy',
 'superman',
 'nighthawk',
 'forest',
 'miamidolphins',
 'minnesotavikings',
 'christmas',
 'joomla',
 'pizelex',
 'haikus',
 'palewood',
 'purplin',
 'inbox',
 'blush',
 'backtothefuture',
 'poncho',
 'greenandblue',
 'lightorange',
 'netflix',
 'littleleaf',
 'deeppurple',
 'backtoearth',
 'mastercard',
 'clearsky',
 'passion',
 'timber',
 'betweennightandday',
 'sagepersuasion',
 'lizard',
 'piglet',
 'darkknight',
 'curiosityblue',
 'ukraine',
 'greentodark',
 'freshturboscent',
 'kokocaramel',
 'virginamerica',
 'portrait',
 'turquoiseflow',
 'vine',
 'flickr',
 'instagram',
 'twitch',
 'pastelorangeatthesun',
 'endlessriver',
 'predawn',
 'purplebliss',
 'talkingtomiceelf',
 'hersheys',
 'crazyorangei',
 'betweentheclouds',
 'metallictoad',
 'martini',
 'friday',
 'servquick',
 'behongo',
 'soundcloud',
 'facebookmessenger',
 'shore',
 'cheerupemokid',
 'amethyst',
 'manofsteel',
 'neonlife',
 'teallove',
 'redmist',
 'starfall',
 'dancetoforget',
 'parklife',
 'cherryblossoms',
 'shadownight',
 'ash',
 'virgin',
 'earthly',
 'dirtyfog',
 'thestrain',
 'reef',
 'candy',
 'autumn',
 'winter',
 'foreverlost',
 'almost',
 'moor',
 'aqualicious',
 'mistymeadow',
 'kyoto',
 'siriustamed',
 'jonquil',
 'petrichor',
 'alostmemory',
 'vasily',
 'blurrybeach',
 'namn',
 'daytripper',
 'pinotnoir',
 'miaka',
 'army',
 'shrimpy',
 'influenza',
 'calmdarya',
 'bourbon',
 'stellar',
 'clouds',
 'moonrise',
 'peach',
 'dracula',
 'mantle',
 'titanium',
 'opa',
 'seablizz',
 'midnightcity',
 'mystic',
 'shroomhaze',
 'moss',
 'borabora',
 'veniceblue',
 'electricviolet',
 'kashmir',
 'steelgray',
 'mirage',
 'juicyorange',
 'mojito',
 'cherry',
 'pinky',
 'seaweed',
 'purpleparadise',
 'sunrise',
 'aquamarine',
 'aubergine',
 'bloodymary',
 'mangopulp',
 'frozen',
 'rosewater',
 'horizon',
 'lemontwist',
 'emeraldwater',
 'intuitivepurple',
 'greenbeach',
 'sunnydays',
 'playingwithreds',
 'harmonicenergy',
 'coolbrown',
 'youtube',
 'noontodusk',
 'nimvelo']
 module.exports = {
   classes
 }



// WEBPACK FOOTER //
// ./src/components/progress/assets/gradient-classes.js